import { Component, input, model } from '@angular/core';
import { ClIcon } from '@corelabs/angular/ui';
import { IconNode } from 'lucide';

@Component({
    selector: 'app-panel',
    templateUrl: './panel.component.html',
    styleUrl: './panel.component.css',
    imports: [ClIcon],
})
export class PanelComponent {
    icon = input<IconNode>();
    title = input.required<string>();
    description = input<string>();
    /** A second tab after the title's; the consumer swaps its content while `tabOpen` is on. */
    tab = input<string>();
    tabOpen = model(false);
}
